<template>
	<div class="add-product">
		<el-tabs
			@tab-click="handleTab"
			:tab-position="'left'"
			style="position: absolute; padding: 20px 0; width: 100%"
			:value="tabValue">
			<el-tab-pane
				v-for="(item, index) in tabset"
				:key="index"
				:label="item.title"
				:name="item.index"
				style="width: 99%">
				<!-- 广告投放组 -->
				<template v-if="index == 0">
					<!-- 搜索栏目 -->
					<div class="search-user">
						<div class="el-search" style="border-radius: 0">
							<div class="el-left">
								<el-button
									type="primary"
									size="small"
									icon="el-icon-plus"
									hidden
									@click="handleAddEditGroup"
									>{{ $t("common.add") }}</el-button
								>
							</div>
							<div class="el-right">
								<el-form
									ref="user"
									:model="groupSearch"
									:inline="true"
									label-width="10px"
									size="small"
									class="demo-form-inline el-input-height">
									<el-form-item prop="nickName">
										<el-input
											v-model="groupSearch.userName"
											:placeholder="$t('adverput.nickName')"></el-input>
									</el-form-item>
									<el-form-item prop="name">
										<el-input
											v-model="groupSearch.name"
											:placeholder="$t('adverput.name')"></el-input>
									</el-form-item>
									<el-form-item>
										<el-button
											type="primary"
											@click="handleSearchGroup"
											icon="el-icon-search"
											>{{ $t("common.search") }}</el-button
										>
										<el-button
											@click="handleResetGroup"
											icon="el-icon-refresh"
											>{{ $t("common.reset") }}</el-button
										>
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>
					<!-- 搜索表格 -->
					<el-table
						v-loading="loadingGroup"
						:data="groupData"
						:empty-text="$t('common.noData')"
						:element-loading-text="$t('common.loading')"
						border
						style="width: 100%">
						<el-table-column
							fixed
							prop="nickName"
							:label="$t('adverput.nickName')"
							width="180"
							align="center"></el-table-column>
						<el-table-column
							prop="name"
							:label="$t('adverput.name')"
							width="180"
							align="center"></el-table-column>
						<el-table-column
							prop="totalTime"
					:formatter="(row) => $formatDate(row.totalTime)"
							:label="$t('adverput.totalTime')"
							width="120"
							align="center"></el-table-column>
						<el-table-column
							prop="notes"
							:label="$t('adverput.notes')"
							align="center"></el-table-column>
						<el-table-column
							prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
							:label="$t('adverput.createTime')"
							width="160"
							align="center"></el-table-column>
						<el-table-column
							fixed="right"
							:label="$t('common.operate')"
							width="300"
							align="center">
							<template slot-scope="scope">
								<el-button size="mini" @click="handleAddEditGroup(scope.row)">{{
									$t("common.edit")
								}}</el-button>
								<el-button
									type="warning"
									icon="el-icon-data-analysis"
									size="mini"
									@click="handleConfigGroupAds(scope.row)"
									style="padding: 7px"
									>{{ $t("advertGroup.advertConfig") }}</el-button
								>
								<el-button
									type="danger"
									icon="el-icon-delete"
									size="mini"
									@click="handleDeleteGroup(scope.row)"
									style="padding: 7px"
									>{{ $t("common.delete") }}</el-button
								>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination
						background
						layout="total,sizes,prev, pager, next,jumper"
						:current-page="groupPage.pageIndex"
						:total="groupPage.totalSize"
						:page-size="groupPage.pageSize"
						@size-change="currentGroupChangeSize"
						@current-change="currentGroupChange"></el-pagination>
					<!-- 添编分组 -->
					<el-dialog
						:modal-append-to-body="true"
						:append-to-body="true"
						:visible.sync="addEditGroupVisible"
						:title="adsGroupForm.id ? $t('adverput.edit') : $t('adverput.add')"
						v-dialogDrag
						:close-on-click-modal="false"
						width="400px"
						custom-class="dialogClass">
						<div
							v-loading="loadingGroupForm"
							:element-loading-text="$t('common.request')">
							<el-form :model="adsGroupForm">
								<el-row :gutter="20">
									<el-col :span="24">
										<el-form-item prop="name" style="margin: 0; height: 80px">
											<div>{{ $t("adverput.name") }}</div>
											<el-input
												v-model="adsGroupForm.name"
												:placeholder="$t('adverput.pName')"
												autocomplete="off"></el-input>
										</el-form-item>
										<el-form-item prop="name" style="margin: 0">
											<div>{{ $t("adverput.notes") }}</div>
											<el-input
												type="textarea"
												v-model="adsGroupForm.notes"
												:placeholder="$t('adverput.pRemarks')"
												autocomplete="off"></el-input>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
						<div slot="footer" class="dialog-footer">
							<el-button size="small" @click="handleCancelAddEditGroup">{{
								$t("common.cancel")
							}}</el-button>
							<el-button
								size="small"
								type="primary"
								:disabled="loadingGroupForm"
								@click="handleSubmitGroupForm"
								>{{ $t("common.definite") }}</el-button
							>
						</div>
					</el-dialog>
					<!-- 配置广告 -->
					<el-dialog
						:modal-append-to-body="true"
						:append-to-body="true"
						:title="$t('adverput.config')"
						:visible.sync="addEditCfgAdsVisible"
						v-dialogDrag
						:close-on-click-modal="false"
						width="80%"
						custom-class="dialogClass">
						<div style="margin-bottom: 20px">
							<el-form :model="configAdsForm">
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item prop="type" style="margin: 0 !important">
											<div>{{ $t("adverput.sftj") }}</div>
											<el-select
												v-model="configAdsForm.type"
												:placeholder="$t('adverput.qxz')"
												@change="advertChange">
												<el-option
													:label="$t('adverput.ytjgglb')"
													value="1"></el-option>
												<el-option
													:label="$t('adverput.wtjgglb')"
													value="0"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item prop="position" style="margin: 0">
											<div>{{ $t("adverput.xswz") }}</div>
											<el-select
												v-model="configAdsForm.display"
												@change="positionChange"
												:no-data-text="$t('common.noData')"
												:no-match-text="$t('common.noData')"
												:placeholder="$t('adverput.qxz')">
												<el-option
													v-for="item in showPosition"
													:key="item.id"
													:label="item.label"
													:value="item.value"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
						<el-table
							v-loading="loadingGroupAds"
							@selection-change="selectChange"
							:data="groupAdsData"
							:empty-text="$t('common.noData')"
							:element-loading-text="$t('common.loading')"
							border
							style="width: 100%; height: 500px; overflow-y: scroll">
							<el-table-column
								type="selection"
								width="55"
								align="center"></el-table-column>
							<el-table-column
								width="130"
								:formatter="formatterShowPosition"
								:label="$t('adverput.xswz')"
								align="center"></el-table-column>
							<el-table-column
								:label="$t('adverts.showContent')"
								align="center"
								width="180">
								<template slot-scope="scope">
									<template v-if="scope.row.type == 0">
										<el-tooltip
											class="item"
											effect="dark"
											:content="$t('advertGroupRela.big')"
											placement="top-start">
											<el-image
												style="height: 102px"
												:preview-src-list="imageList"
												:src="scope.row.url"
												fit="cover"></el-image>
										</el-tooltip>
									</template>
									<template v-else>
										<video
											:src="scope.row.url"
											:controls="true"
											style="
												width: 120px !important;
												height: 100px !important;
											"></video>
									</template>
								</template>
							</el-table-column>
							<el-table-column
								prop="head"
								:label="$t('advertGroupRela.title')"></el-table-column>
							<el-table-column
								prop="startTime"
					:formatter="(row) => $formatDate(row.startTime)"
								:label="$t('advertGroupRela.startTime')"
								width="180"></el-table-column>
							<el-table-column
								prop="endTime"
					:formatter="(row) => $formatDate(row.endTime)"
								:label="$t('advertGroupRela.endDate')"
								width="180"></el-table-column>
						</el-table>
						<el-pagination
							background
							layout="total,sizes,prev, pager, next,jumper"
							:current-page="adsPageconfig.pageIndex"
							:total="adsPageconfig.totalSize"
							:page-size="adsPageconfig.pageSize"
							@size-change="loadGroupAdsSize"
							@current-change="loadGroupAds"></el-pagination>
						<div
							slot="footer"
							class="dialog-footer"
							style="padding-top: 0 !important">
							<el-button size="small" @click="handleCancelGroupAds">{{
								$t("common.cancel")
							}}</el-button>
							<el-button
								size="small"
								type="primary"
								:disabled="loadingGroupAds"
								@click="handleSubmitGroupCfgForm"
								>{{ $t("common.definite") }}</el-button
							>
						</div>
					</el-dialog>
				</template>
				<!-- 广告计划 -->
				<template v-if="index == 1">
					<!-- 搜索栏目 -->
					<div class="search-user">
						<div class="el-search" style="border-radius: 0">
							<div class="el-left">
								<el-button
									type="primary"
									size="small"
									icon="el-icon-plus"
									hidden
									@click="handleAddEditPlan('')"
									>{{ $t("common.add") }}</el-button
								>
							</div>
							<div class="el-right">
								<el-form
									ref="user"
									:model="planSearch"
									:inline="true"
									label-width="10px"
									size="small"
									class="demo-form-inline el-input-height">
									<el-form-item prop="name">
										<el-input
											v-model="planSearch.name"
											:placeholder="$t('adverput.jhname')"></el-input>
									</el-form-item>
									<el-form-item prop="type">
										<el-select
											v-model="planSearch.type"
											filterable
											:no-data-text="$t('common.noData')"
											:no-match-text="$t('common.noData')"
											:placeholder="$t('adverput.pMode')">
											<el-option
												v-for="item in modeList"
												:key="item.id"
												:label="item.label"
												:value="item.value"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item>
										<el-button
											type="primary"
											@click="handleSearchPlan"
											icon="el-icon-search"
											>{{ $t("common.search") }}</el-button
										>
										<el-button
											@click="handleResetPlan"
											icon="el-icon-refresh"
											>{{ $t("common.reset") }}</el-button
										>
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>
					<!-- 搜索表格 -->
					<el-table
						v-loading="loadingPlan"
						:data="planDataList"
						:empty-text="$t('common.noData')"
						:element-loading-text="$t('common.loading')"
						border
						style="width: 100%">
						<el-table-column
							fixed="left"
							prop="name"
							:label="$t('adverput.jhname')"
							width="180"
							align="center"></el-table-column>
						<el-table-column
							:formatter="formatterMode"
							:label="$t('adverput.mode')"
							width="120"
							align="center"></el-table-column>
						<el-table-column
							:formatter="formatterAdsGroup"
							:label="$t('adverput.launchGroupId')"
							width="210"
							align="center"></el-table-column>
						<el-table-column
							prop="price"
							:label="$t('adverput.budget')"
							width="80"
							align="center"></el-table-column>
						<!-- <el-table-column prop="startDate" :label="$t('adverput.startDate')" width="130" align="center"></el-table-column> -->
						<el-table-column
							:label="$t('adverput.startTime')"
							width="230"
							align="center">
							<template slot-scope="scope">
								<div>{{ scope.row.startDate }}</div>
								<div>to</div>
								<div>{{ scope.row.endDate }}</div>
							</template>
						</el-table-column>
						<el-table-column
							:label="$t('adverput.time')"
							width="230"
							align="center">
							<template slot-scope="scope">
								<div v-for="time in scope.row.timelabel" :key="time">
									{{ time }}
								</div>
								<div v-if="scope.row.timelabel.length >= 5">...</div>
							</template>
						</el-table-column>
						<el-table-column
							prop=""
							:label="$t('adverput.plays')"
							width="110"
							align="center"></el-table-column>
						<el-table-column
							prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
							:label="$t('adverput.createTime')"
							width="160"
							align="center"></el-table-column>
						<el-table-column
							prop="state"
							:label="$t('adverput.state')"
							width="160"
							align="center">
							<template #default="scope">
								<template v-if="scope.row.state == 0">{{
									$t("adverput.noStart")
								}}</template>
								<template v-else-if="scope.row.state == 1">{{
									$t("adverput.starting")
								}}</template>
								<template v-else-if="scope.row.state == 2">{{
									$t("adverput.ended")
								}}</template>
							</template></el-table-column
						>
						<el-table-column
							fixed="right"
							:label="$t('common.operate')"
							width="155"
							align="center">
							<template slot-scope="scope">
								<el-button size="mini" @click="handleAddEditPlan(scope.row)">{{
									$t("common.edit")
								}}</el-button>
								<el-button
									type="danger"
									icon="el-icon-delete"
									size="mini"
									@click="handleDeletePlan(scope.row)"
									style="padding: 7px"
									>{{ $t("common.delete") }}</el-button
								>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination
						background
						layout="total,sizes,prev, pager, next,jumper"
						:current-page="planPage.pageIndex"
						:total="planPage.totalSize"
						:page-size="planPage.pageSize"
						@size-change="currentPlanChangeSize"
						@current-change="currentPlanChange"></el-pagination>
					<!-- 添加编辑弹窗 -->
					<el-dialog
						:modal-append-to-body="true"
						:append-to-body="true"
						:title="
							adsPlanForm.id ? $t('adverput.editplan') : $t('adverput.addplan')
						"
						:visible.sync="addEditPlanVisible"
						v-dialogDrag
						:close-on-click-modal="false"
						width="1140px"
						custom-class="dialogClass">
						<div
							v-loading="loadingPlanForm"
							:element-loading-text="$t('common.request')">
							<el-form :model="adsPlanForm">
								<el-row :gutter="20">
									<el-col :span="6">
										<el-form-item prop="name" style="margin: 0">
											<div style="height: 40px; line-height: 40px">
												<label style="color: red">*</label>
												{{ $t("adverput.jhname") }}
											</div>
											<el-input
												v-model="adsPlanForm.name"
												:placeholder="$t('adverput.pJhname')"
												autocomplete="off"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="6">
										<el-form-item prop="sort" style="margin: 0">
											<div style="height: 40px; line-height: 40px">
												{{ $t("adverput.sort") }}
											</div>
											<el-input
												type="number"
												v-model="adsPlanForm.sort"
												:placeholder="$t('adverput.pSort')"
												autocomplete="off"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="6">
										<el-form-item prop="type" style="margin: 0">
											<div style="height: 40px; line-height: 40px">
												<label style="color: red">*</label>
												{{ $t("adverput.mode") }}
											</div>
											<el-select
												v-model="adsPlanForm.type"
												:no-data-text="$t('common.noData')"
												:no-match-text="$t('common.noData')"
												:placeholder="$t('adverput.pMode')">
												<el-option
													v-for="item in modeList"
													:key="item.id"
													:label="item.label"
													:value="+item.value"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="6">
										<el-form-item prop="price" style="margin: 0">
											<div style="height: 40px; line-height: 40px">
												<label style="color: red">*</label>
												{{ $t("adverput.ribudget") }}
											</div>
											<el-input
												v-model="adsPlanForm.price"
												:placeholder="$t('adverput.pRibudget')"
												autocomplete="off">
												<template v-if="adsPlanForm.type == 1" slot="append">{{
													$t("adverput.zlcmt")
												}}</template>
												<template v-if="adsPlanForm.type == 2" slot="append">{{
													$t("adverput.zldmt")
												}}</template>
												<template v-if="adsPlanForm.type == 3" slot="append">{{
													$t("adverput.zlmmt")
												}}</template>
											</el-input>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="6">
										<el-form-item prop="teamId" style="margin: 0">
											<div style="height: 40px; line-height: 40px">
												<label style="color: red">*</label>
												{{ $t("adverput.launchGroupId") }}
											</div>
											<el-select
												v-model="adsPlanForm.teamId"
												:no-data-text="$t('common.noData')"
												:no-match-text="$t('common.noData')"
												:placeholder="$t('adverput.pLaunchGroupId')">
												<el-option
													v-for="item in adsGroupList"
													:key="item.id"
													:label="item.name"
													:value="item.id"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="6">
										<el-form-item prop="userEquipmentTeamId" style="margin: 0">
											<div style="height: 40px; line-height: 40px">
												<label style="color: red">*</label>
												{{ $t("adverput.teamId") }}
											</div>
											<el-select
												v-model="adsPlanForm.userEquipmentTeamId"
												multiple
												:no-data-text="$t('common.noData')"
												:no-match-text="$t('common.noData')"
												:placeholder="$t('adverput.pUserMachineGroupId')">
												<el-option
													v-for="item in machineGroupList"
													:key="item.id"
													:label="item.name"
													:value="item.id"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item style="margin: 0">
											<div style="height: 40px; line-height: 40px">
												<label style="color: red">*</label>
												{{ $t("adverput.startTime") }}
											</div>
											<el-date-picker
												v-model="dateset"
												type="daterange"
												:range-separator="$t('adverput.zhistr')"
												:start-placeholder="$t('adverput.startdate')"
												:end-placeholder="$t('adverput.enddate')"
												@change="handleDateChange"
												style="width: 100%"></el-date-picker>
										</el-form-item>
									</el-col>
								</el-row>
								<!-- 选择日期后出现 -->
								<el-row v-if="totalweeks.length > 0" :gutter="20">
									<el-col
										:span="24"
										style="
											background-color: var(--vtm-well);
											padding: 10px;
											margin: 15px 12px;
											width: 1100px;
										">
										<div style="display: flex; width: 1078px">
											<div
												style="
													font-size: 12px;
													height: 40px;
													line-height: 40px;
													width: 65px;
												">
												<el-checkbox
													@change="handleAll"
													v-model="AllSelect"
													:label="$t('adverput.all')"
													name="type"></el-checkbox>
											</div>
											<div class="wu" style="display: flex; width: 1013px">
												<div class="block">00:00</div>
												<div class="block">01:00</div>
												<div class="block">02:00</div>
												<div class="block">03:00</div>
												<div class="block">04:00</div>
												<div class="block">05:00</div>
												<div class="block">06:00</div>
												<div class="block">07:00</div>
												<div class="block">08:00</div>
												<div class="block">09:00</div>
												<div class="block">10:00</div>
												<div class="block">11:00</div>
												<div class="block">12:00</div>
												<div class="block">13:00</div>
												<div class="block">14:00</div>
												<div class="block">15:00</div>
												<div class="block">16:00</div>
												<div class="block">17:00</div>
												<div class="block">18:00</div>
												<div class="block">19:00</div>
												<div class="block">20:00</div>
												<div class="block">21:00</div>
												<div class="block">22:00</div>
												<div class="block">23:00</div>
											</div>
										</div>
										<div
											v-for="(weeks, i) in totalweeks"
											:key="weeks.id"
											style="display: flex; width: 1078px">
											<div
												style="
													font-size: 12px;
													height: 40px;
													line-height: 40px;
													width: 65px;
												">
												<el-checkbox
													v-model="weeks['check']"
													@change="handleSingle(weeks['check'], i)"
													:label="weeks['week'][0]['showweek']"
													name="type"></el-checkbox>
											</div>
											<div class="you" style="display: flex; width: 1013px">
												<div
													v-for="(week, j) in weeks['week']"
													:key="week.id"
													:class="week.check ? 'block select' : 'block'"
													@click="handleChooseTime(i, j, week)"></div>
											</div>
										</div>
									</el-col>
								</el-row>
								<div v-if="totalweeks.length > 0" style="color: red">
									{{ $t("adverput.tishi") }}
								</div>
							</el-form>
						</div>
						<div
							slot="footer"
							class="dialog-footer"
							style="padding-top: 0 !important">
							<el-button @click="handleCancelAddEditPlan">{{
								$t("common.cancel")
							}}</el-button>
							<el-button
								type="primary"
								:disabled="loadingPlanForm"
								@click="handleSubmitPlanForm"
								>{{ $t("common.definite") }}</el-button
							>
						</div>
					</el-dialog>
				</template>
				<!-- 投放统计 -->
				<template v-if="index == 2">
					<!-- 搜索栏目 -->
					<div class="search-user">
						<div
							class="el-search"
							style="border-radius: 0; margin-bottom: 15px">
							<div class="el-right">
								<el-form
									ref="user"
									:model="tongjiSearch"
									:inline="true"
									label-width="10px"
									size="small"
									class="demo-form-inline el-input-height">
									<el-form-item prop="name">
										<el-input
											v-model="tongjiSearch.userName"
											:placeholder="$t('desktop.userName')"></el-input>
									</el-form-item>
									<el-form-item prop="name">
										<el-input
											v-model="tongjiSearch.launchName"
											:placeholder="$t('desktop.launchName')"></el-input>
									</el-form-item>
									<el-form-item>
										<el-button
											type="primary"
											@click="handleSearchStatistics"
											icon="el-icon-search"
											>{{ $t("common.search") }}</el-button
										>
										<el-button
											@click="handleResetStatistics"
											icon="el-icon-refresh"
											>{{ $t("common.reset") }}</el-button
										>
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>
					<!-- 搜索表格 -->
					<el-table
						v-loading="loadingStatistics"
						:data="statisticsList"
						:empty-text="$t('common.noData')"
						:element-loading-text="$t('common.loading')"
						border
						style="width: 100%">
						<el-table-column
							fixed
							prop="userName"
							:label="$t('desktop.userName')"
							align="center"></el-table-column>
						<el-table-column
							fixed
							:formatter="formatterAdsGroup"
							:label="$t('desktop.launchGroup')"
							align="center"></el-table-column>
						<el-table-column
							fixed
							prop="launchName"
							:label="$t('desktop.launchName')"
							align="center"></el-table-column>
						<el-table-column
							fixed
							prop="price"
							:label="$t('desktop.price')"
							align="center"></el-table-column>
						<el-table-column
							fixed
							prop="launchNum"
							:label="$t('desktop.launchNum')"
							align="center"></el-table-column>
						<el-table-column
							fixed
							prop="launchDuration"
							:label="$t('desktop.launchDuration')"
							align="center"></el-table-column>
						<el-table-column :label="$t('desktop.launchDate')" align="center">
							<template slot-scope="scope">
								<div>{{ scope.row.startDate }}</div>
								<div>to</div>
								<div>{{ scope.row.endDate }}</div>
							</template>
						</el-table-column>
						<el-table-column :label="$t('desktop.launchTime')" align="center">
							<template slot-scope="scope">
								<div v-for="time in scope.row.timelabel" :key="time">
									{{ time }}
								</div>
								<div v-if="scope.row.timelabel.length >= 5">...</div>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination
						background
						layout="total,sizes,prev, pager, next,jumper"
						:current-page="statisticsPage.pageIndex"
						:total="statisticsPage.totalSize"
						:page-size="statisticsPage.pageSize"
						@size-change="getReleaseStatisticsSize"
						@current-change="getReleaseStatistics"></el-pagination>
				</template>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
export default {
	name: "iclist",
	data() {
		return {
			labelPosition: "top",
			setting: {},
			//  左侧菜单栏目
			tabValue: "0",
			tabset: [
				{
					id: 1,
					className: "",
					title: this.$t("adverput.tfz"),
				},
				{
					id: 2,
					className: "",
					title: this.$t("adverput.tfjh"),
				},
				{
					id: 3,
					className: "",
					title: this.$t("adverput.tftj"),
				},
			],
			//  第一个页面：分组列表
			loadingGroup: false,
			groupSearch: {
				nickName: "",
				name: "",
			},
			groupPage: {
				pageIndex: 1,
				pageSize: 10,
				totalSize: 0,
			},
			groupData: [],
			addEditGroupVisible: false,
			loadingGroupForm: false,
			adsGroupForm: {
				id: "",
				name: "",
				notes: "",
			},
			//  第一个页面：配置广告
			addEditCfgAdsVisible: false,
			loadingGroupAds: false,
			configAdsForm: {
				adPlanTeamId: 0,
				type: "0",
				display: "1",
				pageSize: 10,
				pageIndex: 1,
			},
			adsPageconfig: {
				totalSize: 0,
				pageSize: 10,
				pageIndex: 1,
			},
			groupAdsData: [],
			showPosition: [],
			//  第二个页面：广告计划
			loadingPlan: false,
			planSearch: {
				name: "",
				type: "",
			},
			planPage: {
				pageSize: 10,
				pageIndex: 1,
				totalSize: 0,
			},
			planDataList: [],
			addEditPlanVisible: false,
			loadingPlanForm: false,
			adsPlanForm: {
				id: "",
				name: "",
				type: "",
				sort: "",
				price: "",
				teamId: "",
				userEquipmentTeamId: [],
				startDate: "",
				endDate: "",
				config: {
					time: [],
				},
			},
			totalweeks: [],
			dateset: [],
			modeList: [],
			AllSelect: false,
			//  广告组
			adsGroupPage: {
				pageSize: 1000,
				pageIndex: 1,
				totalSize: 0,
			},
			adsGroupList: [],
			//  设备组
			machineGroupPage: {
				pageSize: 1000,
				pageIndex: 1,
				totalSize: 0,
			},
			machineGroupList: [],
			//  广告计划列表组
			planLists: [],
			statisticsSearch: {
				userName: "",
				launchName: "",
			},
			loadingStatistics: false,
			statisticsPage: {
				pageSize: 10,
				pageIndex: 1,
				totalSize: 0,
			},
			statisticsList: [],
			locale: {},
			teamId: "",
			tongjiSearch: {
				userName: "",
				launchName: "",
			},
		};
	},
	mounted() {
		let _self = this;
		if (parseInt(_self.tabValue) == 0) {
			//  广告投放组
			_self.currentGroupChange();
			_self.loadShowPosition();
		} else if (parseInt(_self.tabValue) == 1) {
			//  广告计划
			_self.currentPlanChange();
			_self.loadMachineGroup();
			_self.loadMode();
		} else if (parseInt(_self.tabValue) == 2) {
			//  广告组
			_self.loadAdsGroup();
			//  广告统计
			_self.getReleaseStatistics();
		}
	},
	methods: {
		handlerGetGGW() {
			console.log(22);
			let _self = this;
			let url = _self.$url.Promote.get;
			let method = _self.$method.get;
			_self.$api
				.request(url, method, {
					key: "AD_PLAN",
				})
				.then(res => {
					if (res.code === 0) {
						let setting = {};
						setting.operationScreenOnce = res.data.operationScreenOnce;
						setting.operationTopOnce = res.data.operationTopOnce;
						setting.advertScreenOnce = res.data.advertScreenOnce;
						this.setting = setting;
					}
				})
				.catch(err => {
					_self.$notify({
						title: _self.$t("common.tip"),
						message: err.msg,
						type: "error",
					});
				});
		},
		handleChangeLaunch() {
			let url = this.$url.Promote.save;
			let method = this.$method.post;
			let setting = {
				operationScreenOnce: this.setting.operationScreenOnce,
				operationTopOnce: this.setting.operationTopOnce,
				advertScreenOnce: this.setting.advertScreenOnce,
			};
			this.$api
				.request(url, method, {
					type: "AD_PLAN",
					content: JSON.stringify(setting),
				})
				.then(res => {
					if (res.code === 0) {
						this.$notify({
							title: this.$t("common.tip"),
							message: res.msg,
							type: "success",
						});
					} else {
						this.$notify({
							title: this.$t("common.tip"),
							message: res.msg,
							type: "error",
						});
					}
				})
				.catch(err => {
					this.$notify({
						title: this.$t("common.tip"),
						message: err.msg,
						type: "error",
					});
				});
		},
		handleTab(tab) {
			let _self = this;
			_self.tabValue = tab.index;
			if (parseInt(_self.tabValue) == 0) {
				//  广告投放组
				_self.currentGroupChange();
				_self.loadShowPosition();
			} else if (parseInt(_self.tabValue) == 1) {
				//  广告计划
				_self.currentPlanChange();
				_self.loadMachineGroup();
				_self.loadMode();
			} else if (parseInt(_self.tabValue) == 2) {
				//  广告组
				_self.loadAdsGroup();
				//  广告统计
				_self.getReleaseStatistics();
			} else if (parseInt(_self.tabValue) == 3) {
				_self.handlerGetGGW();
			}
		},
		getReleaseStatisticsSize(pageSize) {
			this.statisticsPage.pageSize = pageSize;
			this.getReleaseStatistics();
		},
		//  加载投放统计
		getReleaseStatistics(pageIndex) {
			let _self = this;
			_self.loadingStatistics = true;
			_self.statisticsPage.pageIndex = pageIndex ? pageIndex : 1;
			let obj = _self.$cloud.objMerge(
				_self.statisticsSearch,
				_self.statisticsPage
			);
			_self.$api
				.request(_self.$url.Advertising.countpage, _self.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						let records = res.data.records;
						for (let i = 0; i < records.length; i++) {
							let times = records[i].time;
							let totaltimes = [];
							for (let i = 0; i < times.length; i++) {
								let weeklabel = "";
								switch (parseInt(times[i]["week"])) {
									case 1:
										weeklabel = this.$t("adverput.z1");
										break;
									case 2:
										weeklabel = this.$t("adverput.z2");
										break;
									case 3:
										weeklabel = this.$t("adverput.z3");
										break;
									case 4:
										weeklabel = this.$t("adverput.z4");
										break;
									case 5:
										weeklabel = this.$t("adverput.z5");
										break;
									case 6:
										weeklabel = this.$t("adverput.z6");
										break;
									case 7:
										weeklabel = this.$t("adverput.z7");
										break;
								}
								let str =
									weeklabel +
									" " +
									times[i]["start"] +
									" To " +
									times[i]["end"];
								if (totaltimes.length < 5) {
									totaltimes.push(str);
								}
							}
							records[i].timelabel = totaltimes;
						}
						_self.statisticsList = records;
						_self.statisticsPage.totalSize = parseInt(res.data.total);
					}
					_self.loadingStatistics = false;
				})
				.catch(() => {
					_self.loadingStatistics = false;
				});
		},
		//  查询统计按钮
		handleSearchStatistics() {
			let _self = this;
			_self.getReleaseStatistics();
		},
		//  重置统计按钮
		handleResetStatistics() {
			let _self = this;
			_self.statisticsSearch.userName = "";
			_self.statisticsSearch.launchName = "";
			_self.getReleaseStatistics();
		},
		//  ====================第二个页面====================  //
		//  加载广告组
		loadAdsGroup(pageIndex) {
			let _self = this;
			_self.adsGroupPage.pageIndex = pageIndex ? pageIndex : 1;
			_self.$api
				.request(
					_self.$url.Advertising.grouppage,
					_self.$method.get,
					_self.adsGroupPage
				)
				.then(res => {
					if (res.code === 0) {
						let records = res.data.records;
						_self.adsGroupList = records;
					}
				})
				.catch(() => {});
		},
		//  渲染广告组
		formatterAdsGroup(row) {
			let _self = this;
			let launchGroup = "";
			for (let i = 0; i < _self.adsGroupList.length; i++) {
				if (_self.adsGroupList[i]["id"] == row.teamId && !launchGroup) {
					launchGroup = _self.adsGroupList[i]["name"];
				}
			}
			return launchGroup;
		},
		//  渲染推广时段
		formatterTime(row) {
			let times = row.time;
			let totaltime = "";
			for (let i = 0; i < times.length; i++) {
				let weeklabel = "";
				switch (parseInt(times[i]["week"])) {
					case 1:
						weeklabel = this.$t("adverput.z1");
						break;
					case 2:
						weeklabel = this.$t("adverput.z2");
						break;
					case 3:
						weeklabel = this.$t("adverput.z3");
						break;
					case 4:
						weeklabel = this.$t("adverput.z4");
						break;
					case 5:
						weeklabel = this.$t("adverput.z5");
						break;
					case 6:
						weeklabel = this.$t("adverput.z6");
						break;
					case 7:
						weeklabel = this.$t("adverput.z7");
						break;
				}
				//  let str = times[i]['createTime']+'(周'+weeklabel+')'+' '+times[i]['start']+'到'+times[i]['endDate'];
				let str =
					weeklabel + " " + times[i]["start"] + " To " + times[i]["end"];
				if (totaltime) {
					totaltime += str;
				} else {
					totaltime = str;
				}
			}
			return totaltime;
		},
		//  加载设备组
		loadMachineGroup(pageIndex) {
			let _self = this;
			_self.machineGroupPage.pageIndex = pageIndex ? pageIndex : 1;
			_self.$api
				.request(
					_self.$url.UserMachineGroup.page,
					_self.$method.get,
					_self.machineGroupPage
				)
				.then(res => {
					if (res.code === 0) {
						_self.machineGroupList = res.data.records;
					}
				})
				.catch(() => {});
		},
		//  加载计划列表
		currentPlanChangeSize(pageSize) {
			this.planPage.pageSize = pageSize;
			this.currentPlanChange();
		},
		currentPlanChange(pageIndex) {
			let _self = this;
			_self.loadingPlan = true;
			_self.planPage.pageIndex = pageIndex ? pageIndex : 1;
			let obj = _self.$cloud.objMerge(_self.planSearch, _self.planPage);
			_self.$api
				.request(_self.$url.Advertising.planpage, _self.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						let records = res.data.records;
						for (let i = 0; i < records.length; i++) {
							let times = records[i].config.time;
							let totaltimes = [];
							for (let i = 0; i < times.length; i++) {
								let weeklabel = "";
								switch (parseInt(times[i]["week"])) {
									case 1:
										weeklabel = this.$t("adverput.z1");
										break;
									case 2:
										weeklabel = this.$t("adverput.z2");
										break;
									case 3:
										weeklabel = this.$t("adverput.z3");
										break;
									case 4:
										weeklabel = this.$t("adverput.z4");
										break;
									case 5:
										weeklabel = this.$t("adverput.z5");
										break;
									case 6:
										weeklabel = this.$t("adverput.z6");
										break;
									case 7:
										weeklabel = this.$t("adverput.z7");
										break;
								}
								let str =
									weeklabel +
									" " +
									times[i]["start"] +
									" To " +
									times[i]["end"];
								if (totaltimes.length < 5) {
									totaltimes.push(str);
								}
							}
							records[i].timelabel = totaltimes;
						}
						_self.planDataList = records;
						_self.planPage.totalSize = parseInt(res.data.total);
					}
					_self.loadingPlan = false;
				})
				.catch(() => {
					_self.loadingPlan = false;
				});
		},
		//  查询计划按钮
		handleSearchPlan() {
			let _self = this;
			_self.currentPlanChange();
		},
		//  重置计划按钮
		handleResetPlan() {
			let _self = this;
			_self.planSearch.name = "";
			_self.planSearch.type = "";
			_self.currentPlanChange();
		},
		//  添编计划按钮
		handleAddEditPlan(row) {
			let _self = this;
			if (row) {
				_self.teamId = row.teamId;
				_self.adsPlanForm.id = row.id;
				_self.adsPlanForm.name = row.name;
				_self.adsPlanForm.type = row.type;
				_self.adsPlanForm.sort = row.sort;
				_self.adsPlanForm.price = row.price;
				_self.adsPlanForm.teamId = row.teamId;
				_self.adsPlanForm.userEquipmentTeamId = row.userEquipmentTeamId;
				//  设置默认开始结束日期
				_self.adsPlanForm.startDate = row.startDate ? row.startDate : "";
				_self.adsPlanForm.endDate = row.endDate ? row.endDate : "";
				let times = row.config.time;
				if (row.startDate && row.endDate) {
					let startDate = new Date(Date.parse(row.startDate));
					let endDate = new Date(Date.parse(row.endDate));
					//  获取这段时间的所有周期数
					let totalweeks = _self.getAllWeeks(startDate, endDate);
					let totalnum = 0;
					let xznum = 0;
					for (let i = 0; i < totalweeks.length; i++) {
						for (let j = 0; j < totalweeks[i]["week"].length; j++) {
							totalnum++;
							for (let z = 0; z < times.length; z++) {
								if (
									totalweeks[i]["week"][j]["week"] == times[z]["week"] &&
									totalweeks[i]["week"][j]["start"] == times[z]["start"] &&
									totalweeks[i]["week"][j]["end"] == times[z]["end"]
								) {
									totalweeks[i]["week"][j]["check"] = true;
									totalweeks[i]["week"][j]["id"] = times[z]["id"];
									xznum++;
								}
							}
						}
					}
					//  是否全选
					if (totalnum == xznum) {
						_self.AllSelect = true;
						for (let i = 0; i < totalweeks.length; i++) {
							totalweeks[i]["check"] = true;
						}
					} else {
						for (let i = 0; i < totalweeks.length; i++) {
							let xnum = 0;
							for (let j = 0; j < totalweeks[i]["week"].length; j++) {
								if (totalweeks[i]["week"][j]["check"]) {
									xnum++;
								}
							}
							if (xnum == totalweeks[i]["week"].length) {
								totalweeks[i]["check"] = true;
							}
						}
					}
					//  默认赋值
					_self.dateset = [row.startDate, row.endDate];
					_self.totalweeks = totalweeks;
				}
				for (let y = 0; y < times.length; y++) {
					delete times[y].createTime;
					delete times[y].delFlag;
					delete times[y].launchId;
					delete times[y].updateDate;
				}
				_self.adsPlanForm.config.time = times;
			} else {
				_self.adsPlanForm = {
					id: "",
					name: "",
					type: "",
					sort: "",
					price: "",
					teamId: "",
					userEquipmentTeamId: [],
					startDate: "",
					endDate: "",
					config: {
						time: [],
					},
				};
				_self.teamId = "";
				_self.dateset = [];
				_self.totalweeks = [];
			}
			_self.loadAdsGroup();
			_self.addEditPlanVisible = true;
		},
		//  取消计划按钮
		handleCancelAddEditPlan() {
			let _self = this;
			_self.addEditPlanVisible = false;
		},
		//  提交计划按钮
		handleSubmitPlanForm() {
			let _self = this;
			let id = _self.adsPlanForm.id;
			if (!_self.adsPlanForm.name) {
				_self.$notify({
					title: _self.$t("common.tip"),
					message: this.$t("adverput.pJhname"),
					type: "warning",
				});
				return false;
			}
			if (!_self.adsPlanForm.type) {
				_self.$notify({
					title: _self.$t("common.tip"),
					message: this.$t("adverput.pMode"),
					type: "warning",
				});
				return false;
			}
			if (!_self.adsPlanForm.price) {
				_self.$notify({
					title: _self.$t("common.tip"),
					message: this.$t("adverput.pRibudget"),
					type: "warning",
				});
				return false;
			}
			if (!_self.adsPlanForm.teamId) {
				_self.$notify({
					title: _self.$t("common.tip"),
					message: this.$t("adverput.pLaunchGroupId"),
					type: "warning",
				});
				return false;
			}
			if (_self.adsPlanForm.userEquipmentTeamId.length < 1) {
				_self.$notify({
					title: _self.$t("common.tip"),
					message: this.$t("adverput.pUserMachineGroupId"),
					type: "warning",
				});
				return false;
			}
			if (!_self.adsPlanForm.startDate || !_self.adsPlanForm.endDate) {
				_self.$notify({
					title: _self.$t("common.tip"),
					message: this.$t("adverput.pBeginDate"),
					type: "warning",
				});
				return false;
			}
			if (
				!_self.adsPlanForm.config ||
				_self.adsPlanForm.config.time.length < 1
			) {
				_self.$notify({
					title: _self.$t("common.tip"),
					message: this.$t("adverput.pTime"),
					type: "warning",
				});
				return false;
			}
			_self.loadingPlanForm = true;
			const obj = {};
			Object.keys(_self.adsPlanForm).forEach(key => {
				obj[key] = _self.adsPlanForm[key] ? _self.adsPlanForm[key] : "";
			});
			let url = _self.$url.Advertising.planinsert;
			let method = _self.$method.post;
			if (id) {
				url = _self.$url.Advertising.planupdate;
				method = _self.$method.put;
			}
			// 去除脏数据
			let times = obj.config.time;
			let newtimes = [];
			for (let ti = 0; ti < times.length; ti++) {
				delete times[ti].check;
				delete times[ti].id;
				delete times[ti].showweek;
				newtimes.push(times[ti]);
			}
			_self.$api
				.request(url, method, obj)
				.then(res => {
					if (res.code === 0) {
						_self.$notify({
							title: _self.$t("common.tip"),
							message: res.msg,
							type: "success",
						});
						_self.currentPlanChange();
						_self.handleCancelAddEditPlan();
					} else {
						_self.$notify({
							title: _self.$t("common.tip"),
							message: res.msg,
							type: "warning",
						});
					}
					_self.loadingPlanForm = false;
				})
				.catch(() => {
					_self.loadingPlanForm = false;
				});
		},
		//  删除计划
		handleDeletePlan(row) {
			let _self = this;
			_self
				.$confirm(_self.$t("adverput.delplan"), _self.$t("common.warning"), {
					confirmButtonText: _self.$t("common.definite"),
					cancelButtonText: _self.$t("common.cancel"),
					type: "warning",
				})
				.then(() => {
					_self.$api
						.request(_self.$url.Advertising.plandelete, _self.$method.delete, {
							id: row.id,
						})
						.then(res => {
							if (res.code === 0) {
								_self.$notify({
									title: _self.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								_self.currentPlanChange();
							}
						});
				});
		},
		//  日期选择改变
		handleDateChange(e) {
			let _self = this;
			_self.adsPlanForm.startDate = "";
			_self.adsPlanForm.endDate = "";
			_self.adsPlanForm.config.time = [];
			_self.totalweeks = [];
			if (e) {
				let ee = JSON.parse(JSON.stringify(e));
				// const startDate = ee[0];
				// const endDate = ee[1];
				let startDate = new Date(Date.parse(ee[0]));
				let endDate = new Date(Date.parse(ee[1]));
				// console.log(startDate);
				// console.log(endDate);
				var year = startDate.getFullYear();
				var month =
					startDate.getMonth().toString().length === 1
						? "0" + startDate.getMonth().toString()
						: startDate.getMonth();
				month = parseInt(month) + 1;
				if (parseInt(month) < 10) {
					month = "0" + parseInt(month);
				}
				var day =
					startDate.getDate().toString().length === 1
						? "0" + startDate.getDate()
						: startDate.getDate();
				if (parseInt(day) < 10) {
					day = "0" + parseInt(day);
				}
				var startDateStr = year + "-" + month + "-" + day;
				_self.adsPlanForm.startDate = startDateStr;
				year = endDate.getFullYear();
				month =
					endDate.getMonth().toString().length === 1
						? "0" + endDate.getMonth().toString()
						: endDate.getMonth();
				month = parseInt(month) + 1;
				if (parseInt(month) < 10) {
					month = "0" + parseInt(month);
				}
				day =
					endDate.getDate().toString().length === 1
						? "0" + endDate.getDate()
						: endDate.getDate();
				if (parseInt(day) < 10) {
					day = "0" + parseInt(day);
				}
				var endDateStr = year + "-" + month + "-" + day;
				_self.adsPlanForm.endDate = endDateStr;
				// //  获取这段时间的所有周期数
				let totalweeks = _self.getAllWeeks(startDate, endDate);
				_self.totalweeks = totalweeks;
			}
		},
		//  获取日期范围内所有的星期
		getAllWeeks(startDate, endDate) {
			let _self = this;
			var weekList = [];
			let id = 0;
			while (
				endDate.getTime() - startDate.getTime() >= 0 &&
				weekList.length < 7
			) {
				var year = startDate.getFullYear();
				var month =
					startDate.getMonth().toString().length === 1
						? "0" + startDate.getMonth().toString()
						: startDate.getMonth();
				var day =
					startDate.getDate().toString().length === 1
						? "0" + startDate.getDate()
						: startDate.getDate();
				var date = year + "-" + (parseInt(month) + 1) + "-" + day;
				id++;
				let week = _self.getWeekDate(date);
				let newweek = [];
				for (let i = 0; i < 24; i++) {
					if (i < 10) {
						i = "0" + i;
					} else {
						i = i + "";
					}
					let showweek = "";
					switch (week) {
						case 1:
							showweek = _self.$t("adverput.z11");
							break;
						case 2:
							showweek = _self.$t("adverput.z22");
							break;
						case 3:
							showweek = _self.$t("adverput.z33");
							break;
						case 4:
							showweek = _self.$t("adverput.z44");
							break;
						case 5:
							showweek = _self.$t("adverput.z55");
							break;
						case 6:
							showweek = _self.$t("adverput.z66");
							break;
						case 7:
							showweek = _self.$t("adverput.z77");
							break;
					}
					let zhi = {
						id: id + parseInt(i),
						showweek: showweek,
						check: false,
						week: week,
						start: i + ":00:00",
						end: i + ":59" + ":59",
					};
					newweek.push(zhi);
				}
				let newweeks = {
					check: false,
					week: newweek,
				};
				console.log(weekList);
				weekList.push(newweeks);
				startDate.setDate(startDate.getDate() + 1);
			}
			return _self.unique(weekList);
		},
		//  获取当前日期星期几
		getWeekDate(time) {
			var now = new Date(time);
			var day = now.getDay();
			var weeks = [7, 1, 2, 3, 4, 5, 6];
			var week = weeks[day];
			return week;
		},
		// 去重
		unique(arr) {
			arr = arr.sort();
			return Array.from(new Set(arr));
		},
		//  选择时段
		handleChooseTime(i, j, row) {
			console.log(row);
			let _self = this;
			_self.totalweeks[i]["week"][j]["check"] = !row.check;
			console.log(_self.totalweeks, 999);
			if (row.check) {
				//  新增
				_self.adsPlanForm.config.time.push(row);
			} else {
				//  移除
				let times = _self.adsPlanForm.config.time;
				for (let s = 0; s < times.length; s++) {
					if (
						times[s]["end"] == row.end &&
						times[s]["start"] == row.start &&
						times[s]["week"] == row.week
					) {
						_self.adsPlanForm.config.time.splice(s, 1);
					}
				}
			}
			console.log(_self.adsPlanForm.config.time);
			let yxnum = 0;
			for (let z = 0; z < _self.totalweeks[i]["week"].length; z++) {
				if (_self.totalweeks[i]["week"][z]["check"]) {
					yxnum++;
				}
			}
			if (yxnum == _self.totalweeks[i]["week"].length) {
				_self.totalweeks[i]["check"] = true;
			} else {
				_self.totalweeks[i]["check"] = false;
			}
			let yxrow = 0;
			for (let s = 0; s < _self.totalweeks.length; s++) {
				if (_self.totalweeks[s]["check"] > 0) {
					yxrow++;
				}
			}
			if (_self.totalweeks.length == yxrow) {
				_self.AllSelect = true;
			} else {
				_self.AllSelect = false;
			}
		},
		//  全选/非全选按钮
		handleAll(check) {
			let _self = this;
			//  操作效果和表单提交值
			let totalweeks = _self.totalweeks;
			_self.adsPlanForm.config.time = [];
			for (let i = 0; i < totalweeks.length; i++) {
				totalweeks[i]["check"] = check;
				for (let j = 0; j < totalweeks[i]["week"].length; j++) {
					totalweeks[i]["week"][j]["check"] = check;
					if (check) {
						_self.adsPlanForm.config.time.push(totalweeks[i]["week"][j]);
					} else {
						_self.adsPlanForm.config.time = [];
					}
				}
			}
			console.log(_self.adsPlanForm.config.time);
		},
		//  单选按钮
		handleSingle(checked, index) {
			let _self = this;
			console.log(checked, index);
			//  操作效果和表单提交值
			let totalweeks = _self.totalweeks;
			for (let i = 0; i < totalweeks[index]["week"].length; i++) {
				totalweeks[index]["week"][i]["check"] = checked;
			}
			let yxrow = 0;
			for (let i = 0; i < totalweeks.length; i++) {
				if (totalweeks[i]["check"] > 0) {
					yxrow++;
				}
			}
			if (totalweeks.length == yxrow) {
				_self.AllSelect = true;
			} else {
				_self.AllSelect = false;
			}
			_self.adsPlanForm.config.time = [];
			for (let i = 0; i < totalweeks.length; i++) {
				for (let j = 0; j < totalweeks[i]["week"].length; j++) {
					if (totalweeks[i]["week"][j]["check"]) {
						_self.adsPlanForm.config.time.push(totalweeks[i]["week"][j]);
					}
				}
			}
			console.log(_self.adsPlanForm.config.time);
		},
		//  ====================第一个页面====================  //
		advertChange(e) {
			let _self = this;
			_self.configAdsForm.type = e;
			_self.loadGroupAds();
		},
		positionChange(e) {
			let _self = this;
			_self.configAdsForm.display = e;
			_self.loadGroupAds();
		},
		//  加载分组列表
		currentGroupChangeSize(pageSize) {
			this.groupPage.pageSize = pageSize;
			this.currentGroupChange();
		},
		currentGroupChange(pageIndex) {
			let _self = this;
			_self.loadingGroup = true;
			_self.groupPage.pageIndex = pageIndex ? pageIndex : 1;
			let obj = _self.$cloud.objMerge(_self.groupSearch, _self.groupPage);
			_self.$api
				.request(_self.$url.Advertising.grouppage, _self.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						_self.groupData = res.data.records;
						_self.groupPage.totalSize = parseInt(res.data.total);
					}
					_self.loadingGroup = false;
				})
				.catch(() => {
					_self.loadingGroup = false;
				});
		},
		//  查询分组按钮
		handleSearchGroup() {
			let _self = this;
			_self.currentGroupChange();
		},
		//  重置分组按钮
		handleResetGroup() {
			let _self = this;
			_self.groupSearch.name = "";
			_self.groupSearch.nickName = "";
			_self.currentGroupChange();
		},
		//  添编分组按钮
		handleAddEditGroup(row) {
			let _self = this;
			if (row) {
				_self.adsGroupForm = {
					id: row.id,
					name: row.name,
					notes: row.notes,
				};
			} else {
				_self.adsGroupForm = {
					id: "",
					name: "",
					notes: "",
				};
			}
			_self.addEditGroupVisible = true;
		},
		//  取消分组按钮
		handleCancelAddEditGroup() {
			let _self = this;
			_self.addEditGroupVisible = false;
		},
		//  提交分组表单
		handleSubmitGroupForm() {
			let _self = this;
			if (!_self.adsGroupForm.name) {
				_self.$notify({
					title: _self.$t("common.tip"),
					message: this.$t("adverput.pName"),
					type: "warning",
				});
				return false;
			}
			_self.loadingGroupForm = true;
			const obj = {};
			Object.keys(_self.adsGroupForm).forEach(key => {
				obj[key] = _self.adsGroupForm[key] ? _self.adsGroupForm[key] : "";
			});
			let url = _self.$url.Advertising.groupinsert;
			let method = _self.$method.post;
			if (_self.adsGroupForm.id) {
				url = _self.$url.Advertising.groupupdate;
				method = _self.$method.put;
			}
			_self.$api
				.request(url, method, obj)
				.then(res => {
					if (res.code === 0) {
						_self.$notify({
							title: _self.$t("common.tip"),
							message: res.msg,
							type: "success",
						});
						_self.currentGroupChange();
						_self.handleCancelAddEditGroup();
					} else {
						_self.$toolUtil.msg(res, _self.error);
					}
					_self.loadingGroupForm = false;
				})
				.catch(() => {
					_self.loadingGroupForm = false;
				});
		},
		//  删除分组信息
		handleDeleteGroup(row) {
			let _self = this;
			_self
				.$confirm(_self.$t("adverput.ggzdelts"), _self.$t("common.warning"), {
					confirmButtonText: _self.$t("common.definite"),
					cancelButtonText: _self.$t("common.cancel"),
					type: "warning",
				})
				.then(() => {
					_self.$api
						.request(_self.$url.Advertising.groupdelete, _self.$method.delete, {
							id: row.id,
						})
						.then(res => {
							if (res.code === 0) {
								_self.$notify({
									title: _self.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								_self.currentGroupChange();
							}
						});
				});
		},
		//  配置分组广告
		handleConfigGroupAds(row) {
			let _self = this;
			_self.configAdsForm.adPlanTeamId = row.id;
			_self.loadGroupAds();
			_self.addEditCfgAdsVisible = true;
		},
		loadGroupAdsSize(pagesize) {
			this.adsPageconfig.pageSize = pagesize;
			this.loadGroupAds();
		},
		//  加载分组广告
		loadGroupAds(pageIndex) {
			let _self = this;
			_self.loadingGroupAds = true;
			_self.adsPageconfig.pageIndex = pageIndex ? pageIndex : 1;
			let obj = _self.$cloud.objMerge(_self.configAdsForm, _self.adsPageconfig);
			_self.$api
				.request(_self.$url.Advertising.advertconfig, _self.$method.get, obj)
				.then(res => {
					if (parseInt(res.code) === 0) {
						_self.groupAdsData = res.data.records;
						_self.adsPageconfig.totalSize = parseInt(res.data.total);
					}
					_self.loadingGroupAds = false;
				})
				.catch(() => {
					_self.loadingGroupAds = false;
				});
		},
		//  取消分组广告
		handleCancelGroupAds() {
			let _self = this;
			_self.addEditCfgAdsVisible = false;
		},
		selectChange(val) {
			this.selectList = val;
			this.imageList = [];
		},
		//  提交分组广告
		handleSubmitGroupCfgForm() {
			let _self = this;
			_self.configAdsForm.ids = _self.selectList;
			_self.configAdsForm.uId = _self.selectList ? _self.selectList[0].uId : "";
			// 切换type
			if (_self.configAdsForm.type == "0") {
				_self.configAdsForm.type = "1";
			} else if (_self.configAdsForm.type == "1") {
				_self.configAdsForm.type = "0";
			}
			_self.$api
				.request(
					_self.$url.Advertising.updateAdvertConfig,
					_self.$method.put,
					_self.configAdsForm
				)
				.then(res => {
					if (res.code === 0) {
						_self.$notify({
							title: this.$t("common.tip"),
							message: res.msg,
							type: "success",
						});
						_self.currentGroupChange();
					} else {
						_self.$message.warning(res.msg);
					}
					delete _self.configAdsForm.advertGroupId;
					delete _self.configAdsForm.ids;
					delete _self.configAdsForm.uId;
					_self.addEditCfgAdsVisible = false;
				})
				.catch(err => {
					_self.$notify({
						title: this.$t("common.tip"),
						message: err.msg,
						type: "error",
					});
					delete _self.configAdsForm.advertGroupId;
					delete _self.configAdsForm.ids;
					delete _self.configAdsForm.uId;
					_self.addEditCfgAdsVisible = false;
				});
		},
		//  加载显示位置
		loadShowPosition() {
			let _self = this;
			_self.$api.dict("gp_show_type").then(res => {
				if (res.code === 0) {
					_self.showPosition = res.data;
				}
			});
		},
		//  渲染显示位置
		formatterShowPosition(row) {
			let _self = this;
			return this.$cloud.getDictLabel(_self.showPosition, row.display);
		},
		//  加载投放模式
		loadMode() {
			let _self = this;
			_self.$api.dict("ads_mode").then(res => {
				if (res.code === 0) {
					_self.modeList = res.data;
				}
			});
		},
		//  渲染投放模式
		formatterMode(row) {
			let _self = this;
			return this.$cloud.getDictLabel(_self.modeList, row.type);
		},
	},
};
</script>

<style lang="scss" scoped>
.wu .block {
	width: 42.1px;
	height: 43.1px;
	line-height: 43.1px;
	text-align: center;
	font-size: 12.5px;
	cursor: pointer;
	color: var(--vtm-ink-3);
}
.you .block {
	width: 43.1px;
	height: 43.1px;
	line-height: 43.1px;
	text-align: center;
	font-size: 12.5px;
	cursor: pointer;
	color: var(--vtm-ink-3);
	background-color: var(--vtm-surface);
	border-right: 1px solid var(--vtm-line);
	border-bottom: 1px solid var(--vtm-line);
}
.you .select {
	background-color: var(--vtm-mint-soft);
}
.add-product {
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: var(--vtm-surface);
}
.el-dialog__body {
	height: auto !important;
	padding-top: 0 !important;
}
.el-form-item__content {
	margin-left: 0 !important;
}
::v-deep .dialogClass {
	.el-dialog__header {
		padding: 20px 20px 10px 20px;
	}
	.el-dialog__body {
		padding: 0 20px;
		height: auto;
	}
	.el-dialog__footer {
		padding: 20px;
	}
}
</style>
